import React from 'react';
import styled from 'styled-components';
import LoaderZp from '../../assets/gif/loader_zp_250x250.gif';
import LoaderUb from '../../assets/gif/loader_ur_250x250.gif';
import LoaderCM from '../../assets/gif/loading_cm.svg';

const siteId = process.env.REACT_APP_BUILD_SITE;

const obtainLogobySite = site => {
  switch (site) {
    case 'CMBR':
      return LoaderCM;
    case 'UBPE':
      return LoaderUb;
    default:
      return LoaderZp;
  }
};

const Loader = ({ width = '80px', height = '80px' }) => {
  return <LoaderImg width={width} height={height} src={obtainLogobySite(siteId)} alt='logo' />;
};

const LoaderImg = styled.img`
  width: ${props => props.width};
  height: ${props => props.height};
`;

export default Loader;
